import { createReducer, on } from '@ngrx/store';

import { ICompanyPreferences } from '@shared/types/company/company-preferences.type';

import {
    set_company_preferences,
    set_company_preferences_failure,
    set_company_preferences_success,
} from '../actions/company.action';

const initialState: ICompanyPreferences = {
    currencyAndNumbers: {
        currency: null,
        decimalSeparator: null,
        negatives: null,
        precision: null,
        roundingMethod: null,
        symbol: null,
        symbolPositioning: null,
        thousandsSeparator: null,
    },
    percentageOptions: {
        symbol: '%',
        symbolPositioning: 'right',
    },
    dateAndTime: {
        locale: null,
        timezone: null,
    },
    allCurrencies: [],
    id: '',
    name: 'None',
    preferred_language: 'en-US',
    eod: '',
    hasPreTenderVoidAmounts: false,
    hasLiabilitySalesIntoGrossSales: false,
    hasStartingAmount: false,
    hasActiveEvents: false,
    hasChildCategories: false,
    backOfficeCurrencyAndNumbers: {
        calculationPrecision: null,
        quantityPrecision: null,
    },
    costMethod: 'last_purchase_cost',
    backOffice: {
        transferDisplayQohFromSetting: false,
        standWorksheetPostClosureSetting: true,
    },
    reportGroupingMethod: 'create_time',
};

const _companyReducer = createReducer(
    initialState,
    on(set_company_preferences, (state): ICompanyPreferences => state),
    on(set_company_preferences_failure, (): ICompanyPreferences => initialState),
    on(
        set_company_preferences_success,
        (state, { preferences }): ICompanyPreferences => ({ ...state, ...preferences }),
    ),
);

export function companyReducer(state, action) {
    return _companyReducer(state, action);
}
